module.exports = __webpack_public_path__ + "img/chart.41fbc404.png";